module.exports = __webpack_public_path__ + "img/cso-img.0476f633.png";